import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../../api/api";

export default function IndividualClientDetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [client, setClient] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        api.get(`/Client/${id}`)
            .then((res) => setClient(res.data))
            .catch(() => setError("Failed to load client"));
    }, [id]);

    if (error) return <p className="text-red-500">{error}</p>;
    if (!client) return <p>Loading...</p>;

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">
                Client #{client.id}
            </h2>

            <p><b>Name:</b> {client.name}</p>
            <p><b>Last Name:</b> {client.lastName}</p>
            <p><b>Email:</b> {client.email}</p>
            <p><b>Phone:</b> {client.phoneNumber}</p>

            <button
                className="mt-4 bg-gray-300 px-4 py-2 rounded"
                onClick={() => navigate("/admin/individual-clients")}
            >
                Back
            </button>
        </div>
    );
}